import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  holder: {
    display: 'flex',
    alignItems: 'center'
  },

  root: {
    position: 'relative',
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '61px',
    backgroundColor: 'white'
  },

  type: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '4px',
    height: '100%'
  },

  avatarHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '0.25rem',
    marginRight: '0.875rem',
    minWidth: '60px',
    height: 'auto'
  },

  avatar: {
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  contentHolder: {
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  },

  content: {
    borderRadius: '10px',
    width: 'calc(100% - 1rem)',
    height: 'calc(100% - 1rem)',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },

    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
